// Base units available for composition
// Shared between UnitAutocomplete and FormulaInput
export const BASE_UNITS = [
    // Mass
    { value: 'kg', description: 'kilogram (mass)' },
    { value: 't', description: 'tonne (mass)' },
    { value: 'g', description: 'gram (mass)' },
    { value: 'lb', description: 'pound (mass)' },
    { value: 'oz', description: 'ounce (mass)' },

    // Distance/Length
    { value: 'm', description: 'meter (distance/length)' },
    { value: 'km', description: 'kilometer (distance)' },
    { value: 'cm', description: 'centimeter (distance)' },
    { value: 'mm', description: 'millimeter (distance)' },
    { value: 'mi', description: 'mile (distance)' },
    { value: 'ft', description: 'foot (distance)' },
    { value: 'in', description: 'inch (distance)' },

    // Area
    { value: 'ha', description: 'hectare (area)' },
    { value: 'acre', description: 'acre (area)' },
    { value: 'm^2', description: 'square meter (area)' },
    { value: 'km^2', description: 'square kilometer (area)' },

    // Volume
    { value: 'L', description: 'liter (volume)' },
    { value: 'mL', description: 'milliliter (volume)' },
    { value: 'm^3', description: 'cubic meter (volume)' },
    { value: 'gal', description: 'gallon (volume)' },

    // Currency
    { value: 'EUR', description: 'euro (currency)' },
    { value: 'USD', description: 'US dollar (currency)' },
    { value: 'GBP', description: 'British pound (currency)' },

    // Time
    { value: 's', description: 'second (time)' },
    { value: 'min', description: 'minute (time)' },
    { value: 'h', description: 'hour (time)' },
    { value: 'day', description: 'day (time)' },
    { value: 'week', description: 'week (time)' },
    { value: 'month', description: 'month (time)' },
    { value: 'year', description: 'year (time)' },

    // Energy/Power
    { value: 'J', description: 'joule (energy)' },
    { value: 'kWh', description: 'kilowatt-hour (energy)' },
    { value: 'W', description: 'watt (power)' },
    { value: 'kW', description: 'kilowatt (power)' },
];

